import type { PatientDetailsQuery } from "$routes/patient/[:patientId]/_lib/__generated__/patient-queries.gql";
import { PatientHasInsurance } from "elephant-web/gql";
import { nestifyObject as unflatten } from "nestify-anything";
import { omit } from "ramda";

const omitInsuranceType = omit(["insuranceType", "__typename"]);

export const getInitialValues = (
  patient: NonNullable<
    NonNullable<PatientDetailsQuery["patientByCardId"]>["patient"]
  >,
) => {
  const { currentVisit } = patient;
  const visitInsuranceProvider =
    currentVisit?.insuranceList?.[currentVisit?.insuranceList?.length - 1];
  const visitInsuranceDetails =
    visitInsuranceProvider?.visitInsuranceDetails ?? {};

  const unflat = {
    ...unflatten({
      "insurance.insuranceType": patient.insurance?.insuranceType ?? "",
      "insurance.insuranceDetails":
        patient.insurance?.insuranceDetails ??
        omitInsuranceType(patient.insurance),
      "insurance.visitInsuranceDetails": visitInsuranceDetails,
      "insurance.patientHasInsurance": patient?.insurance
        ? PatientHasInsurance.Yes
        : patient.patientHasInsurance,
    }),
  };
  return unflat;
};
